import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WhatsAppButton = () => {
  const [phoneNumber, setPhoneNumber] = useState('+919560205515');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setPhoneNumber(response.data.whatsapp_number);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const handleClick = () => {
    const cleanNumber = phoneNumber.replace(/[^0-9]/g, '');
    const whatsappUrl = `https://wa.me/${cleanNumber}?text=Hi%20Tinkred!%20I%20have%20a%20question%20about%20your%20courses.`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      data-testid="whatsapp-btn"
      onClick={handleClick}
      className="fixed bottom-6 left-6 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform z-50"
      title="Chat with us on WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </button>
  );
};

export default WhatsAppButton;